import React, {useState} from "react";
import {useFormMethods, useFormStatic} from "../../DyanmicFormContext.tsx";
import {usePropertyValuationApi} from "../../../../context/ApiContext.tsx";
import Modal from "../../../Modal.tsx";
import SamButton from "../../../SamButton.tsx";
import {CompChangedResponse, SelectableComp, SelectedComp} from "./configurableCompsSelectTypes.tsx";
import {CompSearchRequest, CompSearchResponse} from "../../../../api/ApiTypes.ts";
import {CompSelectType} from "../../DynamicFormTypes.ts";

interface Errors {
    compSlot?: boolean;
    zipCode?: boolean;
    mlsIdOrAddress?: boolean;
    noProperty?: boolean;
    mismatchedType?: boolean;
    notAllowed?: boolean;
}

interface FinderForm {
    compSlot?: number;
    zipCode?: string;
    mlsId?: string;
    address?: string;
}

export interface AddComparableModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedComps: SelectedComp[];
    setSelectedCompAtRow: (comp: SelectableComp, slot: SelectedComp) => Promise<CompChangedResponse>;
}

export const AddComparableModal: React.FC<AddComparableModalProps> = React.memo(({
                                                                                     isOpen,
                                                                                     onClose,
    selectedComps,
    setSelectedCompAtRow
                                                                                 }) => {
    const {triggerValidation} = useFormMethods()
    const {metaData, formPermissions} = useFormStatic()
    const [formData, setFormData] = useState<FinderForm>({
        compSlot: undefined,
        zipCode: '',
        mlsId: '',
        address: ''
    });

    const [errors, setErrors] = useState<Errors>({
        compSlot: false,
        zipCode: false,
        mlsIdOrAddress: false,
        noProperty: false,
        mismatchedType: false,
        notAllowed: false
    })

    const propertyValuationApi = usePropertyValuationApi();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const addComparable = () => {

        setErrors({
            compSlot: false,
            zipCode: false,
            mlsIdOrAddress: false,
            noProperty: false,
            mismatchedType: false,
            notAllowed: false
        });

        if (formData?.compSlot === undefined) {
            setErrors(prev => ({
                ...prev,
                compSlot: true
            }));
            return
        }

        if (formData?.zipCode === undefined || formData?.zipCode === '') {
            setErrors(prev => ({
                ...prev,
                zipCode: true
            }));
            return;
        }

        if (formData?.zipCode && (formData?.mlsId === undefined || formData?.mlsId === '') && (formData?.address === undefined || formData?.address === '')) {
            setErrors(prev => ({
                ...prev,
                mlsIdOrAddress: true
            }));
            return;
        }

        if (!formPermissions.canEdit) {
            setErrors(prev => ({
                ...prev,
                notAllowed: true
            }));
            return;
        }

        setIsSubmitting(true);

        const compSearchRequest: CompSearchRequest = {
            orderId: metaData.orderId,
            fullAddress: formData?.address,
            zip: formData.zipCode,
            mlsListingId: formData.mlsId
        }

        propertyValuationApi.getCompSearch(compSearchRequest).then(async (response: CompSearchResponse) => {

            const selectedComp: SelectedComp = formData.compSlot != undefined ? selectedComps[formData.compSlot] : selectedComps[options[0].selectedCompsIndex];
            const comp: SelectableComp = {
                dgInfo: {
                    dataGridFieldKey: selectedComp.dgInfo.dataGridFieldKey,
                    prefixForApiPopulation: selectedComp.dgInfo.prefixForApiPopulation,
                    requiredType: CompSelectType.SOLD
                },
                propertyValuation: response.comparable
            };

            await setSelectedCompAtRow(comp, selectedComp);
            await triggerValidation();
            onClose();

        }).catch(() => {
            setErrors(prev => ({
                ...prev,
                noProperty: true
            }));
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    const handleAddressOrId = (e: React.ChangeEvent<HTMLInputElement>) => {

        const {name, value} = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (formData?.mlsId || formData?.address) {
            setErrors(prev => ({
                ...prev,
                mlsIdOrAddress: false
            }))
        }
    }

    const options = selectedComps.filter((comp) => comp.address == "").map((comp) => {
        return {
            label: comp
            .dgInfo.requiredType.toString() + " " + (comp.indexOfDg + 1).toString(),
            selectedCompsIndex: selectedComps.indexOf(comp)
        };
    });

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Add Comparable"}
            maxWidth="md"
        >
            <div className="relative w-full min-w-0 group">
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    Choose an Available Comparable Slot<span className="text-red-600">*</span>
                </label>
                <div className="relative w-full min-w-0  mb-4">

                    <div className="flex">
                        <div className="flex-grow relative">
                            <select
                                className="my-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                                value={formData?.compSlot}
                                onChange={(e) => {

                                    if (e.target.value !== undefined) {
                                        setErrors(prevState => ({
                                            ...prevState,
                                            compSlot: false
                                        }));
                                    }
                                    setFormData(prev => ({
                                        ...prev,
                                        compSlot: parseInt(e.target.value)
                                    }))
                                }}
                            >
                                <option value="">{"Select an option"}</option>
                                {options.map((option) => (
                                    <option
                                        key={option.label}
                                        value={option.selectedCompsIndex}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {errors?.compSlot && (<div className="text-red-600">
                        Available Comparable Slot is Required
                    </div>)
                    }
                </div>
            </div>
            <div className="mb-8">
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    Zip Code<span className="text-red-600">*</span>
                </label>

                <input
                    value={formData?.zipCode}
                    onChange={(e) => {

                        if (e.target.value !== undefined) {
                            setErrors(prevState => ({
                                ...prevState,
                                zipCode: false
                            }));
                        }
                        setFormData(prev => ({
                            ...prev,
                            zipCode: e.target.value
                        }))
                    }}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                {errors?.zipCode && (<div className="text-red-600">
                    Zip code is required
                </div>)
                }
            </div>

            <div>
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    MLS ID
                </label>
                <input
                    name="mlsId"
                    value={formData.mlsId}
                    onChange={handleAddressOrId}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                <div className="text-red-600 m-1">
                    OR {errors.mlsIdOrAddress && (<span className="ml-3">MLS Id or Address Needed</span>)}
                </div>
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    Address
                </label>
                <input
                    name="address"
                    value={formData.address}
                    onChange={handleAddressOrId}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
            </div>

            <div className="mt-3 flex justify-between items-center">
                {errors.noProperty ? (
                    <span className="text-red-600">Could not find the property</span>
                ) : (
                    <div></div>
                )}

                {errors.mismatchedType ? (
                    <span className="text-red-600">Search returned incorrect comparable type for your selected slot</span>
                ) : (
                    <div></div>
                )}

                {errors.mismatchedType ? (
                    <span className="text-red-600">You are not allowed to set values on this form</span>
                ) : (
                    <div></div>
                )}

                {isSubmitting ? (
                    <div className="ml-4 flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md">
                        <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor"
                                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 01-8 8z"></path>
                        </svg>
                        Submitting...
                    </div>
                ) : (
                    <SamButton className="ml-4" onClick={addComparable}>
                        Add
                    </SamButton>
                )}
            </div>
        </Modal>
    );
});